import { render, staticRenderFns } from "./AttachmentsDropdown.vue?vue&type=template&id=19303ac0"
import script from "./AttachmentsDropdown.vue?vue&type=script&lang=ts"
export * from "./AttachmentsDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports